/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Basic utility functions

// Import isBlank from the common utilities. Using `import` here breaks compilation.
let checkAll; let clearPlaceholders; let disableButton; let disableFormSubmit; let disableOrSubmitWithValidation; let enableButton; let flashNotice; let hideNotice; let parseDate; let setVisible; let updateUrl;
const {
  isBlank
} = require('../common/utilities/is_blank');

// Namespace
// from https://github.com/jashkenas/coffee-script/wiki/FAQ

const namespace = function(target, name, block) {
  if (arguments.length < 3) { [target, name, block] = Array.from([(typeof exports !== 'undefined' ? exports : window), ...arguments]); }
  const top = target;
  for (const item of Array.from(name.split('.'))) { target = target[item] || (target[item] = {}); }
  return block(target, top);
};

// fixed namespace issue
// https://stackoverflow.com/questions/10484872/uncaught-referenceerror-namespace-is-not-defined-when-namespacing-in-coffeescri
(typeof exports !== 'undefined' && exports !== null ? exports : this).namespace = namespace;

// Ensure LOCALIST_SETTINGS exists as a window global
if (!window.LOCALIST_SETTINGS) { window.LOCALIST_SETTINGS = {}; }

// Define Slzr namespace as an exported object from this module.
//
// Outside of webpack, this defines a global `Slzr` variable.
//
// An additional first argument could be passed into namespace to force it onto window, but
// by not doing so and explicitly treating it as a global in webpack, this file fits into native
// modules more nicely.
namespace('Slzr', function(exports, top) {
  exports.Debug = window.LOCALIST_SETTINGS.development;

  // Try to expose our jquery, moment, and underscore glboally
  exports.jQuery = window.jQuery;
  exports.moment = window.moment;
  exports._ = window._;

  // Common format strings
  exports.Formats = {
    // Date/Time preview formats, used for input previews and instance lists
    DateTime: {
      'en-US': {
        // Long date format, with words
        LongDate: 'dddd, MMMM d, yyyy',
        // Short date format
        ShortDate: 'M/d/yyyy',
        // Long time format
        LongTime: 'h:mm tt'
      },
      'en-GB': {
        // Long date format, with words
        LongDate: 'dddd, MMMM d, yyyy',
        // Short date format
        ShortDate: 'd/M/yyyy',
        // Long time format
        LongTime: 'h:mm tt'
      },
      'en-AU': {
        // Long date format, with words
        LongDate: 'dddd, MMMM d, yyyy',
        // Short date format
        ShortDate: 'd/M/yyyy',
        // Long time format
        LongTime: 'h:mm tt'
      }
    }
  };

  // Activate the appropriate locale for the default formats
  exports.Formats.DateTime.active = exports.Formats.DateTime[LOCALIST_SETTINGS.locale] || exports.Formats.DateTime['en-US'];
  exports.Formats.LongDate = exports.Formats.DateTime.active.LongDate;
  exports.Formats.ShortDate = exports.Formats.DateTime.active.ShortDate;
  return exports.Formats.LongTime = exports.Formats.DateTime.active.LongTime;
});

// Under webpack, `namespace` defines the namespace on `exports`, rather than
// the global window object.
//
// Code following this assumes `Slzr` is implicitly defined via the global variable, so we ensure it's set here.
const {
  Slzr
} = typeof exports !== 'undefined' && exports !== null ? exports : this;


// Configure datejs with the proper locale
Date.CultureInfo = Date.AvailableCultureInfo[LOCALIST_SETTINGS.locale] || Date.AvailableCultureInfo['en-US'];

// Show a flash notice with the specified message
//
// msg: the message to show
window.flashNotice = (flashNotice = function(msg, options) {
  const message_response_message = Slzr.jQuery('#message-response-message');
  const message_response = Slzr.jQuery('#message-response');
  const role = options && options.role;

  if (message_response_message.length > 0) {
    message_response_message.html(msg);
  } else {
    message_response.html(msg);
  }

  message_response.removeAttr('role');
  if (role) {
    message_response.attr('role', role);
  }

  return message_response.fadeIn('slow');
});

// Hide the notice
window.hideNotice = (hideNotice = () => Slzr.jQuery('#message-response').fadeOut('fast'));

// Check all checkboxes in a container
window.checkAll = (checkAll = function(container, el) {
  container = Slzr.jQuery(container);
  el = Slzr.jQuery(el);
  if (!(container.length > 0)) { container = el.closest('form'); }

  const new_state = el.prop('checked');

  container.find('input[type="checkbox"]:enabled')
    .prop('checked', new_state);

  return el.prop('checked', new_state);
});

String.prototype.isBlank = function() { return this.match(/^\s*$/); };

// Extend underscore with isBlank
_.mixin({isBlank(str) { return isBlank(str); }});

// Disable a submit button that is an ajax form submit.
// Basically the rails helper, just without the reset.
// function disableFormSubmit(el, msg) {
window.disableFormSubmit = (disableFormSubmit = function(el, msg) {
  if (window.hiddenCommit) {
    window.hiddenCommit.setAttribute('value', el.value);
  } else {
    window.hiddenCommit = el.cloneNode(false);
    window.hiddenCommit.setAttribute('type', 'hidden');
    el.form.appendChild(hiddenCommit);
  }

  el.setAttribute('originalValue', el.value);

  // Deferring this allows Safari to submit without needing onsubmit/submit called explicitly,
  // while preventing Firefox from submitting twice
  return _.defer(function() {
    el.disabled = true;
    return el.value = msg;
  });
});

// Disables a submit button with a message.
// Doesn't do anything else but change some attributes.
window.disableButton = (disableButton = function(el, msg) {
  if (el = Slzr.jQuery(el)) {
    if (el[0].tagName === 'A') {
      // Mess with inner-html for links
      return el.attr('originalValue', el.html())
        .prop('disabled', true)
        .html(msg);
    } 
      return el.attr('originalValue', el.val())
        .prop('disabled', true)
        .val(msg);
    
  }
});

// Reenable's a submit button disabled with disableButton
window.enableButton = (enableButton = function(el) {
  if (el = Slzr.jQuery(el)) {
    if (el[0].tagName === 'A') {
      return el.prop('disabled', false)
        .html(el.attr('originalValue'))
        .attr('originalValue', null);
    } 
      return el.prop('disabled', false)
        .val(el.attr('originalValue'))
        .attr('originalValue', null);
    
  }
});

window.disableOrSubmitWithValidation = (disableOrSubmitWithValidation = function(el, fn, msg) {
  if (fn()) {
    Slzr.jQuery(el).val(msg);
    return true;
  } 
    return false;
  
});

// Do a date-js type parse of a date in a lightbox, that doesn't use dropdowns internally
window.parseDate = (parseDate = function(lbkey) {
  const input_el = Slzr.jQuery(`#x-date-input-${lbkey}`);
  const output_el = Slzr.jQuery(`#x-date-${lbkey}`);
  const preview_el = Slzr.jQuery(`#x-date-preview-${lbkey}`);
  const error_el = Slzr.jQuery(`#x-date-error-${lbkey}`);
  const input = input_el.val();

  if (input.isBlank()) {
    error_el.show();
    preview_el.html('').hide();
    return false;
  } 
    const parsed_date = Date.parse(input, {bias: 'future_date'});
    if (parsed_date) {
      error_el.hide();
      preview_el.html(parsed_date.toString(Slzr.Formats.LongDate)).show();
      output_el.val(parsed_date.toString('yyyy-MM-dd'));
      return true;
    } 
      preview_el.html('').hide();
      error_el.show();
      return false;
    
  
});

// Update the current URL, changing the specified GET parameters without affecting any others
window.updateUrl = (updateUrl = function(params) {
  const searchParams = new URLSearchParams(location.search);
  for (const key in params) {
    const value = params[key];
    if (value != null) { searchParams.set(key, value); } else { searchParams.delete(key); }
  }
  const query = searchParams.toString();
  return location.search = query ? `?${  query}` : '';
});

// Hide or show el based on the value of visible
window.setVisible = (setVisible = function(el, visible) {
  if (visible == null) { visible = true; }
  if (visible) {
    return Slzr.jQuery(el).show();
  } 
    return Slzr.jQuery(el).hide();
  
});

// Truncate a string to the specified length, optionally on a word boundary
String.prototype.truncate = function(size, on_word, suffix) {
  if (on_word == null) { on_word = true; }
  if (suffix == null) { suffix = '...'; }
  if (this.length > size) {
    // cut it down to size
    let str = this.substring(0, size);
    str = str.split(/\s+/).slice(0, -1).join(' ');
    return str + suffix;
  } 
    return this;
  
};

// POLYFILLS

// Sub String.prototype.normalize in older browsers (namely, IE11 and older Android) to just return the string.
// If we ever need full international support, we may want to look at the +unorm+ library on npm.
if (typeof(String.prototype.normalize) !== 'function') {
  String.prototype.normalize = function() { return this; };
}

// Clear input placeholders
window.clearPlaceholders = (clearPlaceholders = form => Slzr.jQuery("input[placeholder]", form).each(function() {
  const $this = Slzr.jQuery(this);
  if (($this.val() === '') || ($this.val() === $this.attr('placeholder'))) { return $this.val(''); }
}));

// Detect browser
//
// Mainly needed to work around IE7 crashes related to the photo manager
namespace('Slzr.Browser', function(exports, top) {
  exports.IE = false;
  exports.version = false;
  exports.chrome = false;
  exports.safari = false;
  exports.opera = false;
  exports.firefox = false;

  if (navigator.appName === 'Microsoft Internet Explorer') {
    let m;
    exports.IE = true;

    const ua = navigator.userAgent;
    const re = new RegExp('MSIE ([0-9]{1,}[\.0-9]{0,})');

    if ((m = re.exec(ua)) !== null) {
      exports.version = parseFloat(m[1]);
    }
  }

  return (() => {
    const result = [];
    for (const browser of ['chrome', 'safari', 'firefox', 'opera']) {
      exports[browser] = navigator.userAgent.toLowerCase().indexOf(browser) > -1;
      break;
    }
    return result;
  })();
});

// mini-jQuery plugin to wrap on('click', '[data-action]', ()-> ) type calls
// in a little more useful way
(function($) {
  $.fn.onAction = function(action, callback) {
    return $(this).on('click', `[data-action="${  action  }"]`, function(evt) {
      callback.call(this, evt);
      return evt.preventDefault();
    });
  };

  // Update a URL by adding/removing a parameter
  $(document).on('click ifChanged', '[data-action="toggle-param"]', function(evt) {
    const $this = $(this);
    const key = $this.attr('name');
    const value = $this.prop('checked') ? $this.val() : null;

    const new_param = {};
    new_param[key] = value;
    return updateUrl(new_param);
  });

  $(document).onAction('close-lightbox', function(evt) {
    hideIbox();
    const open_url = $(this).data('lightbox-open-url');
    if (open_url) { return window.open($(this).attr('href')); }
  });

  $(document).on('change', '[data-action="check-all"]', function(evt) {
    const $this = $(this);
    const container = $this.data('check-all');
    checkAll(container, $this);
    evt.preventDefault();
    return evt.stopPropagation();
  });

  // Switch between tabs, by hiding/showing elements and toggling a class
  //
  // data-action="switch-tab"
  //
  // Additional data attributes:
  //   data-tab-target: Target tab to switch to (defined by data-tab on appropriate data-tab-group)
  //   data-tab-group: Defines a tab "group" to associate elements together
  $(document).onAction('switch-tab', function(event) {
    event.preventDefault();
    const $this = $(this);
    const tab_group = $this.data('tab-group');
    const tab_target = $this.data('tab-target');
    return $(document).trigger('slzr:switch-tab', [tab_group, tab_target]);
});

  $(document).on('slzr:switch-tab', function(event, tab_group, tab_target) {
    const all_tabs = $(`[data-tab-group=\"${tab_group}\"][data-tab]`);
    const all_links = $(`[data-tab-group=\"${tab_group}\"][data-tab-target]`);

    const target_tab = all_tabs.filter(`[data-tab=\"${tab_target}\"]`);
    const selected_links = all_links.filter(`[data-tab-target=\"${tab_target}\"]`);

    all_links.removeClass('selected');
    selected_links.addClass('selected');

    all_tabs.hide();
    target_tab.show();

    return $(document).trigger('slzr:switched-tab', [tab_group, tab_target]);
});

  // Disable links with a class that ends with `_export_action`
  return $(document).on('click', "button[data-action$='_export_action']", function() {
    // Set disable with text
    const $this = $(this);
    const $label = $('span.label', this);
    const what = $this.data('export-label') || 'CSV';

    const old_label = $label.html();
    $label.html(`Requesting ${what} ...`).attr('disabled', true);
    $this.attr('disabled', true);

    // Do AJAX POST
    return $.post($this.attr('href'))
      .then(function(response) {
        if (!response.queued) { return; }
        flashNotice(response.notice);
        $label.html(`Requested ${what}`);

        // Track any google analytics events that happened
        if (response.track_events != null) {
          return Array.from(response.track_events).map((event) =>
            Slzr.trackGAEvent(event.category, event.action, event.label, event.value));
        } }).fail(function(response) {
        flashNotice('Unable to request report');
        $label.html(old_label);
        return $this.attr('disabled', false); });
});

}(Slzr.jQuery));
